import React, { Component } from "react";

import { Modal, Input, Button } from "antd";
import { Slide } from "react-awesome-reveal";
import { toast } from "react-toastify";

import { AppContext } from "../../AppContext";
import LoginInput from "./Common/LoginInput";

import {
  sendForgotPasswordEmail,
  signIn,
  authenticateCredentials,
} from "../../actions/login";

import genistaLogo from "../../assets/images/logo/genista-logo.svg";
import loginBgIcon from "../../assets/images/logo/login-bg-img.svg";
import loginMainIcon from "../../assets/images/logo/login-main-img.svg";

import "./login.css";
import "./Common/LoginInput.css";

class Login extends Component {
  state = {
    email: "",
    password: "",
    forgotEmail: "",
    isForgotPwd: false,
    isLinkSent: false,
    emailError: false,
    passwordError: false,
    slideOut: false,
    loginLoading: false,
    forgotPwdLoading: false,
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onSubmit = () => {
    const { email, password } = this.state;
    const { onCredentialsSuccess, authenticateFn } = this.props;
    const emailTrimmed = email.trim();
    if (!emailTrimmed && !password) {
      this.setState({ emailError: true, passwordError: true });
      return;
    }
    if (!emailTrimmed) {
      this.setState({ emailError: true, passwordError: false });
      return;
    }
    if (!password) {
      this.setState({ emailError: false, passwordError: true });
      return;
    }

    this.setState({ loginLoading: true }, async () => {
      if (onCredentialsSuccess) {
        const authenticate = authenticateFn || authenticateCredentials;
        const result = await authenticate(emailTrimmed, password);
        if (!result.success) {
          this.setState({ loginLoading: false });
          toast.error(result.message);
          return;
        }

        this.setState({ slideOut: true }, () => {
          window.setTimeout(() => {
            this.setState({ email: "", password: "", loginLoading: false });
            onCredentialsSuccess(result.data, { email: emailTrimmed, password });
          }, 500);
        });
        return;
      }

      signIn(emailTrimmed, password, false, this.context, (result) => {
        const { history } = this.props;
        if (!result.success) {
          this.setState({ loginLoading: false });
          toast.error(result.message);
          return;
        }
        this.setState({ slideOut: true }, () => {
          window.setTimeout(() => {
            this.setState({ email: "", password: "", loginLoading: false });
            history.push(("/sample-submission"));
          }, 500);
        });
      });
    });
  };

  sendResetPwdLink = async () => {
    const { forgotEmail } = this.state;
    const forgotEmailTrimmed = forgotEmail.trim();

    if (!forgotEmailTrimmed) {
      toast.error("Please enter a valid email address");
      return;
    }

    this.setState({ forgotPwdLoading: true }, async () => {
      sendForgotPasswordEmail(forgotEmailTrimmed, (_result) => {
        if (!_result.success) {
          this.setState({ forgotPwdLoading: false });
          toast.error(_result.message);
          return;
        }
        this.setState({
          isForgotPwd: false,
          isLinkSent: true,
          forgotEmail: "",
          forgotPwdLoading: false,
        });
      });
    });
  };

  toggleForgotPwd = () => {
    const { isForgotPwd } = this.state;
    this.setState({
      isForgotPwd: !isForgotPwd,
      forgotEmail: "",
    });
  };

  toggleLinkSent = () => {
    const { isLinkSent } = this.state;
    this.setState({
      isLinkSent: !isLinkSent,
    });
  };

  renderForgotPwdModal = () => {
    const { forgotEmail, forgotPwdLoading } = this.state;
    return (
      <Modal
        open
        maskClosable={false}
        closable={false}
        centered
        footer={null}
        onConfirm={this.sendResetPwdLink}
        width="480px"
        className="forgotPasswordModal"
      >

        <div className="forgotPasswordDel">
          <div className="forgotPasswordDelTitle">Forgot Password? </div>
          <div className="forgotPasswordDelTitleMessage">Enter the email address associated with your account</div>
          <Input
            className="Login__Input ForgotPassword__Input"
            type="text"
            name="forgotEmail"
            value={forgotEmail || ""}
            placeholder="Email"
            onChange={(e) => this.onChange(e)}
          />
          <div className="forgotPasswordBtn">
            <Button
              type="default"
              onClick={this.toggleForgotPwd}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              loading={forgotPwdLoading}
              disable={forgotPwdLoading}
              onClick={() => this.sendResetPwdLink()}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  renderLinkSentModal = () => (
    <Modal
      open
      closable={false}
      centered
      footer={null}
      onConfirm={this.toggleLinkSent}
      onCancel={this.toggleLinkSent}
      width="456px"
      wrapClassName="login"
      className="linkSentModal"
    >
      <div className="forgotPasswordDel">
        <div className="forgotPasswordDelTitle">Link Sent</div>
        <div className="forgotPasswordDelTitleMessage">Follow the link in your email to reset your password.</div>
        <div className="forgotPasswordBtn">
          <Button
            type="primary"
            onClick={this.toggleLinkSent}
          >
            Okay
          </Button>
        </div>
      </div>
    </Modal>
  );

  render() {
    const {
      isForgotPwd,
      isLinkSent,
      email,
      password,
      emailError,
      passwordError,
      slideOut,
      loginLoading,
    } = this.state;
    const { variant = "default", onCredentialsSuccess, history } = this.props;
    const isInternalAuthVariant = variant === "support" || variant === "invite" || !!onCredentialsSuccess;
    const subtitleByVariant = {
      support: "For internal use only. Log in with your information provided by an admin.",
      invite: "Log in to continue and send a customer invite.",
    };
    const subtitle = subtitleByVariant[variant]
      || (isInternalAuthVariant ? subtitleByVariant.support : null)
      || "Log in with your data that you entered during your Sign Up process";

    return (
      <Slide direction="left" triggerOnce reverse={slideOut}>
        <div className="login-page">
          {isForgotPwd && this.renderForgotPwdModal()}
          {isLinkSent && this.renderLinkSentModal()}
          <button
            type="button"
            className="logoLoginPage"
            onClick={() => history.push("/login")}
          >
            <img src={genistaLogo} alt="Genista" />
          </button>
          <form className="loginMainContainer">
            <div className="login-box">
              <div className="login-header">
                {variant === "support" ? "Support Login" : "Log In"}
              </div>
              <div className="login-header-subtitle">
                {subtitle}
              </div>
              <LoginInput
                label="Email ID"
                id="login-email-inputid"
                type="text"
                name="email"
                autoComplete="username"
                value={email}
                onChange={(e) => this.onChange(e)}
                error={emailError}
                clearError={() => this.setState({ emailError: false })}
              />
              <LoginInput
                label="Password"
                id="login-password"
                type="password"
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => this.onChange(e)}
                isPassword
                error={passwordError}
                clearError={() => this.setState({ passwordError: false })}
                onEnter={this.onSubmit}
              />

              {!isInternalAuthVariant && (
                <div className="login-remember-forgot-row">
                  <Button type="link" className="forgot-link" onClick={this.toggleForgotPwd}> Forgot password? </Button>
                </div>
              )}

              <div className="login-button-container">
                <Button
                  type="primary"
                  size="large"
                  className="Login__Button"
                  loading={loginLoading}
                  disable={loginLoading || (!password.length || !email.length)}
                  onClick={() => this.onSubmit()}
                >
                  Log In
                </Button>
              </div>
            </div>

            <div className="loginImage">
              <img
                className="loginImageBubbles"
                src={loginBgIcon}
                alt="login"
              />
              <img
                className="loginImageCharacters"
                src={loginMainIcon}
                alt="login"
              />
            </div>
          </form>
        </div>
      </Slide>
    );
  }
}

Login.contextType = AppContext; // allows class component to consume context, access via this.context
export default Login;
